import { Link, useNavigate } from "react-router-dom";
import PerfilLogo from "../usuarios/PerfilLogo";

function NavBarEstudianteTutor({ estudiante, configuracion}) {    
    const navigate = useNavigate();

    const salirVista=()=>{
        localStorage.removeItem('kte');
        //setVerEstudiante(0);
        navigate('/Principal');
        return;
    };

    return (    
        <>
        <nav className="navbar bg-body-tertiary mb-2">
            <div className="d-flex d-wrap justify-content-center">
                <div className="mx-3"><PerfilLogo id={estudiante.estudiante_id} version="logo_solo" configuracion={configuracion} /></div>
                <div>{estudiante.apellido}, {estudiante.nombre }</div>
                <Link className="btn btn-sm btn-outline-secondary mx-2" to={'/Principal'} >
                    <i className="wrap-icon fa-solid fa-home mr-3 me-1"></i>
                    <span className="menu-text">Principal </span>
                </Link>
                <Link className="btn btn-sm btn-outline-secondary mx-2" to={'/Calificaciones'}>
                    <i className="wrap-icon fa-regular text-warning fa-star mr-3 me-1"></i>
                    <span className="menu-text">Calificaciones</span>
                </Link>
                
            </div>
            <button type="button" onClick={() => salirVista()}>cerrar vista</button>
            <div className="d-flex d-wrap justify-content-end"><div className="btn btn-sm btn-outline-success mx-2">seleccionado por el turor</div></div>
        </nav>
        </>
     );
}

export default NavBarEstudianteTutor;